<template>
  <b-modal
    :title="$t('advancedSearch')"
    id="advanced-search-modal"
    dialog-class="advanced-search-dialog"
    header-close-content=""
    size="xl"
    body-class="advanced-search-modal"
    v-model="localModel"
    @hide="hideHandler">
    <AdvancedSearch
      ref="advancedSearch"
      :advanced-search-id="props.advancedSearchId"
      :execute-search-on-start="props.executeSearchOnStart"
      @hide="hideModal"
      v-model:result-count="vm.resultCount" />
    <template #modal-footer="{ cancel }">
      <div class="footer">
        <div class="footer-result">
          <span v-if="vm.resultCount"> {{ `${$t("searchResults")}: ${vm.resultCount}` }} </span>
        </div>
        <div class="footer-actions">
          <b-btn @click="cancel" data-cy="advanced-search-close-btn">{{ $t("Close") }}</b-btn>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script setup lang="ts">
import { computed, reactive, ref, unref } from "vue";
import { useI18n } from "vue-i18n";
import AdvancedSearch from "./AdvancedSearch.vue";

const props = defineProps<{ value: boolean; advancedSearchId?: string; executeSearchOnStart?: boolean }>();
const emits = defineEmits(["input"]);

const { t: $t } = useI18n();

const vm = reactive({
  resultCount: undefined
});

const localModel = computed({
  get() {
    return props.value;
  },
  set(nv) {
    emits("input", nv);
  }
});

const advancedSearch = ref<InstanceType<typeof AdvancedSearch> | null>(null);

const hideModal = () => {
  localModel.value = false;
};

const hideHandler = (event: any) => {
  const advSearchObj = unref(advancedSearch);
  if (advSearchObj?.states?.isDirty && !confirm($t("confirm.hasUnsavedData"))) event.preventDefault();
};
</script>
